import { z } from 'zod';

export type ExampleEventType = 'Example'
  | 'ExampleBlacklisted'
  | 'ExampleWithPayload'
  | 'Error';

// Example event payload schemas
export const ExamplePayloadSchema = z.object({
  pageId: z.string(),
  pageTitle: z.string(),
  referrer: z.string().optional(),
  url: z.string(),
});

export const ErrorPayloadSchema = z.instanceof(Error);

// Schema for events with no payload
export const EmptyPayloadSchema = z.undefined();

export type ExampleEventTypePayloadMap = {
  Example: undefined;
  ExampleBlacklisted: undefined;
  ExampleWithPayload: z.infer<typeof ExamplePayloadSchema>;
  Error: z.infer<typeof ErrorPayloadSchema>;
};

export const ExampleEventSchemaMap = {
  Example: EmptyPayloadSchema,
  ExampleBlacklisted: EmptyPayloadSchema,
  ExampleWithPayload: ExamplePayloadSchema,
  Error: ErrorPayloadSchema,
};
